import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { OpenPreInfoFormAction } from '../pre-info-form-dialog/pre-info-form-dialog.action';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { Action } from '../../common/actions/core/action';
import { ITimeoutService } from 'angular';
import angular = require('angular');
import { ContractMobileApproveAction } from '../../common/actions/contract-mobile-approve-action';
import UserService from '../../common/services/user/user.service';
import { ContractApproveAction } from '../../common/actions/contract-approve-action';

/* @ngInject */
export default class ContractMobileController implements ActionHandler {
    private infoForm: string;
    private preInfoAggreement: boolean = false;
    private aggreement: boolean = false;
    private onConfirm: any;
    private onPreInfoMobile: any;
    private showPreInfo: boolean = true;
    
    constructor(
        private $sce,
        private $translate,
        private $rootScope,
        private actionDispatcher: ActionDispatcherService,
        private $timeout: ITimeoutService,
        private userService: UserService
    ) {
        this.loadTranslations();
        var _self = this;
        this.$rootScope.$on('$translateChangeSuccess', function (event, a) {
            _self.loadTranslations();
        });
    }

    public loadTranslations() {
        this.$translate('pay.mobilePayInfoForm').then(value => {
            this.infoForm = this.$sce.trustAsHtml(value);
        });

        this.listenClickEvent();
    }

    public $postLink() {
        this.actionDispatcher.register(this);
        this.listenClickEvent();
    }

    public $onDestroy() {
        this.actionDispatcher.unregister(this);
    }

    private listenClickEvent() {

        this.$timeout(() => {
            const infoForm = angular.element('.info-form-mobile');
            if (infoForm) {
                infoForm.on('click', () => {
                    this.onInfoForm();
                })
            }
        });

    }
    public handle(action: Action) {
        if (action instanceof ContractApproveAction) {
            if (action.data && action.data.mobilePayment) {
                this.approveAggreement();
            }
        }
    }

    public onInfoForm() {
        this.onPreInfoMobile();
    }

    private approveAggreement() {
        this.aggreement = true;
        this.confirmContract();
    }

    public onChangeContract() {
        this.confirmContract();
    }

    private confirmContract() {
        this.onConfirm({
            data: {
                mobileAggreement: this.aggreement
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/buy/contract-mobile/contract-mobile.controller.ts